<template>
    <nav class="navbar navbar-expand-lg navbar-dark bg-success">
        <a class="navbar-brand" href="#">C807</a>
        <button class="navbar-toggler" type="button" data-toggle="collapse" data-target="#navbarSupportedContent"
            aria-controls="navbarSupportedContent" aria-expanded="false" aria-label="Toggle navigation">
            <span class="navbar-toggler-icon"></span>
        </button>
        <div class="collapse navbar-collapse" id="navbarSupportedContent">
            <ul class="navbar-nav mr-auto">
                <li class="nav-item dropdown" v-for="i in menu" :key="i.menu">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false">
                        {{ i.nmenu }}
                    </a>
                    <div class="dropdown-menu" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="#" v-for="j in i.opciones" @click.prevent="$emit('set-modulo', j.weblink)"
                            :key="j.menu">{{ j.nmenu }}</a>
                    </div>
                </li>
            </ul>
            <ul class="navbar-nav">
                <li class="nav-item dropdown">
                    <a class="nav-link dropdown-toggle" href="#" id="navbarDropdown" role="button"
                        data-toggle="dropdown" aria-haspopup="true" aria-expanded="false"></a>
                    <div class="dropdown-menu dropdown-menu-right" aria-labelledby="navbarDropdown">
                        <a class="dropdown-item" href="/index.php/sesion/salir">Salir</a>
                    </div>
                </li>
            </ul>
        </div>
    </nav>
</template>

<script>
import axios from 'axios';

export default {
  name: 'AppMenu',
  props: {
    modulo: {
      type: Number,
      required: true
    }
  },
  data: () => ({
      termino: null,
      menu: []
  }),
  created: function() {
    this.getMenu();
  },
  methods: {
    getMenu () {
      axios
      .get(this.UrlAdmin+'/modulo/get_menu/' + this.modulo)
      .then(r => {
        if (r.data.exito) {
          this.menu = r.data.menu
        } else {
          alert(r.data.mensaje);
        }
      })
      .catch(e => {
        alert(e);
      })
    }
  }
}
</script>
